var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crowdPortrait"},[_c('dataAnalysisTemplate',{attrs:{"echoData":_vm.echoData,"showData":_vm.crowdPortrait},on:{"save":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }